module.exports = __webpack_public_path__ + "static/media/geo-vermonter.303ce2c0.png";